var _context, _context2;
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { range, strPad } from '../utils';
export var DATEPICKER = 'Datepicker';
export var hours = _mapInstanceProperty(_context = range(0, 23)).call(_context, function (value) {
  return {
    label: strPad(value, 2),
    value: value
  };
});
export var minutes = _mapInstanceProperty(_context2 = range(0, 59)).call(_context2, function (value) {
  return {
    label: strPad(value, 2),
    value: value
  };
});
export var seconds = minutes;